import React, {useEffect, useMemo, useState} from 'react';
import classes from "./Dashboard.module.scss";
import Container from "../../components/UI/Container/Container";
import {
  Button, Col,
  Divider,
  Dropdown,
  Flex,
  Form, InputNumber,
  Menu,
  message, Modal,
  Row,
  Space,
  Statistic,
  Table,
  Tooltip,
  Typography
} from "antd";
import Block from "../../components/UI/Block/Block";
import {API} from "../../http";
import {NEW_ENDPOINTS} from "../../http/endpoints";
import {PAYMENT_SYSTEM, TRANSACTION_STATUS, TRANSACTION_TYPE} from "../../utils/constants";
import TransactionsTable from "../../components/TransactionsTable/TransactionsTable";
import SearchInput from "../../components/UI/SearchInput/SearchInput";
import {DownOutlined, IssuesCloseOutlined, ReloadOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {ROUTES} from "../../components/AppRouter/AppRouter";
import moment from "moment/moment";
import CloseDayModal from "../../components/CloseDayModal/CloseDayModal";

const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [globalSearchValue, setGlobalSearchValue] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [transactions, setTransactions] = useState([]);

  const navigate = useNavigate();

  const loadTransactions = async () => {
    setLoading(true);
    try {
      const {data} = await API.post(NEW_ENDPOINTS.ADMIN.TRANSACTIONS.LIST);
      setTransactions(data);
    } catch (e) {
      message.error('Failed to get transactions');
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTransactions();
  }, []);

  const filteredTransactions = useMemo(() => {
    const fieldsToCompare = ['id', 'payment_id', 'first_name', 'last_name'];
    if (globalSearchValue) {
      return transactions.filter(item => {
        for (const field of fieldsToCompare) {
          if (item[field] && item[field].toString().toLowerCase().includes(globalSearchValue.toLowerCase())) {
            return true;
          }
        }
        return false;
      });
    } else return transactions;
  }, [globalSearchValue, transactions]);

  const handleMenuClick = (e) => {
    const { key } = e;
    const [paymentType, direction] = key.split('/');
    navigate(`${ROUTES.CREATE_PAYMENT.path}?payment=${paymentType}&type=${direction}`);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.SubMenu key={PAYMENT_SYSTEM.SEPA} title={PAYMENT_SYSTEM.SEPA}>
        <Menu.Item key={`${PAYMENT_SYSTEM.SEPA}/${TRANSACTION_TYPE.SEND}`}>Outgoing ({TRANSACTION_TYPE.SEND})</Menu.Item>
        <Menu.Item key={`${PAYMENT_SYSTEM.SEPA}/${TRANSACTION_TYPE.RECEIVE}`}>Incoming ({TRANSACTION_TYPE.RECEIVE})</Menu.Item>
      </Menu.SubMenu>
      <Menu.SubMenu key={PAYMENT_SYSTEM.SWIFT} title={PAYMENT_SYSTEM.SWIFT}>
        <Menu.Item key={`${PAYMENT_SYSTEM.SWIFT}/${TRANSACTION_TYPE.SEND}`}>Outgoing ({TRANSACTION_TYPE.SEND})</Menu.Item>
        <Menu.Item key={`${PAYMENT_SYSTEM.SWIFT}/${TRANSACTION_TYPE.RECEIVE}`}>Incoming ({TRANSACTION_TYPE.RECEIVE})</Menu.Item>
      </Menu.SubMenu>
    </Menu>
  );

  return (
    <Container className={classes.container}>
      <Block>
        <Flex justify="space-between">
          <Statistic loading={loading} title="New transactions" value={transactions.filter(i => i.status === TRANSACTION_STATUS.NEW).length}
                     precision={0}/>

          <Space size="small">
            <Button onClick={() => setIsModalVisible(true)} icon={<IssuesCloseOutlined />} shape="round" size="large" type="primary" danger>
              Close day
            </Button>
            <Dropdown overlay={menu} trigger={['click']}>
              <Button shape="round" size="large" type="primary">
                Create Payment <DownOutlined />
              </Button>
            </Dropdown>
          </Space>
        </Flex>

        <Divider/>

        <Space className="w100" direction="vertical">
          <Flex style={{ marginBottom: 10 }} justify="space-between" gap={30} className="w100" align="baseline">
            <Flex className="w100" vertical>
              <SearchInput placeholder="Global search by id, payment_id, first_name, last_name"
                           value={globalSearchValue}
                           onChange={(e) => setGlobalSearchValue(e.target.value)}/>
              <Typography.Text style={{fontSize: 12}} type="secondary">{filteredTransactions.length} transactions
                found</Typography.Text>
            </Flex>
            <Space>
              <Tooltip title="Reload">
                <Button icon={<ReloadOutlined/>} onClick={loadTransactions} shape="round" type="primary"/>
              </Tooltip>
            </Space>
          </Flex>
          <TransactionsTable loading={loading} onStatusUpdate={loadTransactions} transactions={filteredTransactions} />
        </Space>
      </Block>

      <CloseDayModal open={isModalVisible} onClose={() => setIsModalVisible(false)} />
    </Container>
  );
};
export default Dashboard;
